import ChangesBanner from './ChangesBanner';
import EPVSCalculations from './EPVSCalculations';
import ExampleJobAlertBanner from './ExampleJobAlertBanner';
import KandaQuoteBanner from './KandaQuoteBanner';
import LeadBanner from './LeadBanner';
import Quote from './Quote';
import Title from './Title';

export default {
  KandaQuoteBanner,
  Title,
  Quote,
  EPVSCalculations,
  ExampleJobAlertBanner,
  LeadBanner,
  ChangesBanner,
};
